var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMobile())?_c('img',{attrs:{"src":require("../assets/ArteMasBanner.gif"),"width":"100%"}}):_c('img',{staticClass:"size-img",attrs:{"src":require("../assets/ArteMasBanner.gif"),"width":"100%","height":"500px"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aa4144c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SwiperPagination.vue
// module id = null
// module chunks = 